// Configurable breakpoints
// These numbers are based on https://material.io/design/layout/responsive_layout_grid.html#breakpoints
export const WINDOW_WIDTH_BREAKPOINTS = {
  phone_minimum: 360,
  phone_large_minimum: 425,
  tablet_minimum: 600, // sm
  tablet_large_minimum: 840,
  desktop_minimum: 1024, // md
  desktop_medium_minimum: 1280,
  desktop_large_minimum: 1440, // lg
};
